const KEY = "cbc_crm_token";

export const getToken   = (): string | null => localStorage.getItem(KEY);
export const setToken   = (t: string)        => localStorage.setItem(KEY, t);
export const clearToken = ()                 => localStorage.removeItem(KEY);
